import React, { FC, useContext, useEffect, useState } from "react";
import { UPSAPIContext, UPSContext } from "@app/provider";
import { defineMessages, useIntl } from "react-intl";

import "./upsReceipt.scss";
import { useNavigate } from "react-router-dom";
import { routes } from "@app/routing";
import { BlueHeaderContent } from "@app/components/ui/layout";
import { LoadingContext } from "@natera/platform/lib/components/context";
import { PdfView } from "@app/components/pdf";
import { downloadPdf } from "@app/postBill/utils/viewPdf";
import { getUpsLocalStorage } from "@app/ups/utils/localStorage";
import { useBillingPdfFile } from "@app/postBill/hooks";
import "@app/postBill/postBill.scss";

const messages = defineMessages({
  upsReceiptTitle: {
    id: "upsReceiptTitle",
    defaultMessage: "Receipt",
  },
});

const UPSReceipt: FC = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const authType = getUpsLocalStorage("authType");
  const guest_token = getUpsLocalStorage("guestToken");
  const {
    upsApiProviderState: { guestValidationData },
    UPS_BASE_API_URL,
    loadingStates,
    getReceiptRequest,
  } = useContext(UPSAPIContext);
  const { upsAccessToken } = useContext(UPSContext);
  const [error, setError] = useState<boolean>(false);
  const [pdfBlob, setPdfBlob] = useState<Blob | null>(null);
  const { file, pdfError } = useBillingPdfFile({
    url: `${UPS_BASE_API_URL}/ups/payment/receipt/${guestValidationData?.receiptId}`,
    token: upsAccessToken,
  });
  const backRoute =
    authType === "guest"
      ? `${routes.upsGuestLogin}?guest_token=${guest_token}`
      : routes.home;

  const fetchPdf = async () => {
    try {
      const arrayBuffer = await getReceiptRequest(
        guestValidationData?.receiptId as string
      );
      const blob = new Blob([arrayBuffer], { type: "application/pdf" });
      setPdfBlob(blob);
    } catch (e) {
      setError(true);
    }
  };

  useEffect(() => {
    if (!guestValidationData?.receiptId) {
      navigate(routes.upsGuestLogin);
      return;
    }
    fetchPdf();
  }, [guestValidationData?.receiptId]);

  const onDownloadPdf = async () => {
    const fileName = intl.formatMessage(messages.upsReceiptTitle);
    downloadPdf(pdfBlob, fileName);
  };

  return (
    <div className="billing-pdf ups-receipt-page">
      <div className="ups-receipt-page__content">
        <BlueHeaderContent
          blueHeaderTitle={intl.formatMessage(messages.upsReceiptTitle)}
          crossHeaderRoute={backRoute}
          fullScreen
        >
          <LoadingContext isLoading={loadingStates.getReceiptRequest}>
            <PdfView
              file={file}
              onDownload={onDownloadPdf}
              hasError={error || pdfError}
            />
          </LoadingContext>
        </BlueHeaderContent>
      </div>
    </div>
  );
};

export default UPSReceipt;
